module.exports = __webpack_public_path__ + "img/wximg4.e4bbf32f.png";